import React, {useEffect} from 'react';
// import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
// import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
// import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
// import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
// import FormatBoldIcon from '@mui/icons-material/FormatBold';
// import FormatItalicIcon from '@mui/icons-material/FormatItalic';
// import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
// import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ZoomInIcon from "@mui/icons-material/ZoomIn"
import ZoomOutIcon from "@mui/icons-material/ZoomOut"
import TodayIcon from '@mui/icons-material/Today';
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import CropIcon from "@mui/icons-material/Crop";
import LinearScaleIcon from '@mui/icons-material/LinearScale';
// import TableChartIcon from '@mui/icons-material/TableChart';
import EventNoteIcon from '@mui/icons-material/EventNote';

import ShowBaselineIcon from '../../../../styles/images/ShowBaselineButton.png';
import ShowPercentCompleteIcon from '../../../../styles/images/ShowPercentCompleteButton.png';
import ShowMilestoneIcon from '../../../../styles/images/ShowMilestoneButton.png';
import { styled, Tooltip, Divider, Paper, ToggleButton, ToggleButtonGroup } from '@mui/material';
const PREFIX = 'GanttToolbar';

const classes = {
    grouped: `${PREFIX}-grouped`,
    paper: `${PREFIX}-paper`,
    divider: `${PREFIX}-divider`,
    performanceKey: `${PREFIX}-performanceKey`,
    milestoneKey: `${PREFIX}-milestoneKey`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.paper}`]: {
        display: 'flex',
        // border: `1px solid ${theme.palette.divider}`,
        flexWrap: 'wrap',
        paddingRight: '5px'
    },

    [`& .${classes.divider}`]: {
        margin: theme.spacing(1, 0.5),
    },

    [`& .${classes.performanceKey}`]: {
        fontSize: '0.875rem',
        height: '48px',
        marginLeft: 'auto'
    },

    [`& .${classes.milestoneKey}`]: {
        fontSize: '0.875rem',
        height: '48px',
        marginLeft: '8px'
    }
}));

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
        margin: theme.spacing(0.5),
        border: 0,
        '&.Mui-disabled': {
            border: 0,
        },
        '&:not(:first-of-type)': {
            borderRadius: theme.shape.borderRadius,
        },
        '&:first-of-type': {
            borderRadius: theme.shape.borderRadius,
        },
    },
}));

export default function GanttToolbar({expandMore, expandLess, zoomIn, zoomOut, zoomToday, zoomFit, zoomRestore, displayBaseline, displayPercentComplete, displayMilestone, displaySplitParents, displayTask, performanceKey, milestoneKey}) {
    const [toggle, setToggle] = React.useState(() => ['baseline', 'percentComplete', 'milestone', 'split', 'tasks']);

    const handleToggle = (event, newToggle) => {
        setToggle(newToggle);
    };

    useEffect(() => {
        const newToggle = toggle;
        if (displayBaseline.checked && toggle.indexOf('baseline') < 0) {
            newToggle.push('baseline');
        } else if (!displayBaseline.checked && toggle.indexOf('baseline') >= 0){
            newToggle.splice(newToggle.indexOf('baseline'), 1);
        }
        if (displayPercentComplete.checked && toggle.indexOf('percentComplete') < 0) {
            newToggle.push('percentComplete');
        } else if (!displayPercentComplete.checked && toggle.indexOf('percentComplete') >= 0){
            newToggle.splice(newToggle.indexOf('percentComplete'), 1);
        }
        if (displayMilestone.checked && toggle.indexOf('milestone') < 0) {
            newToggle.push('milestone');
        } else if (!displayMilestone.checked && toggle.indexOf('milestone') >= 0) {
            newToggle.splice(newToggle.indexOf('milestone'), 1);
        }
        if (displaySplitParents.checked && toggle.indexOf('split') < 0) {
            newToggle.push('split');
        } else if (!displaySplitParents.checked && toggle.indexOf('split') >= 0) {
            newToggle.splice(newToggle.indexOf('split'), 1);
        }
        if (displayTask.checked && toggle.indexOf('tasks') < 0) {
            newToggle.push('tasks');
        } else if (!displayTask.checked && toggle.indexOf('tasks') >= 0) {
            newToggle.splice(newToggle.indexOf('tasks'), 1);
        }
        // Clone the array to force a new render
        setToggle([].concat(newToggle));

    }, [displayBaseline?.checked, displayPercentComplete?.checked, displayMilestone?.checked, displaySplitParents?.checked, displayTask?.checked]);

    let hideFirstDivider = false;
    if (zoomOut.hidden && zoomIn.hidden && zoomToday.hidden && zoomFit.hidden && zoomRestore.hidden) {
        hideFirstDivider = true;
    }

    let hideSecondDivider = false;
    if (displayBaseline.hidden && displayMilestone.hidden && displayPercentComplete.hidden && displaySplitParents.hidden && displayTask.hidden) {
        hideSecondDivider = true;
    }

    let hideThirdDivider = false;
    if (performanceKey === null) {
        hideThirdDivider = true;
    }

    let hideFourthDivider = false;
    if (milestoneKey === null) {
        hideFourthDivider = true;
    }

    // console.log('rendering with ', toggle);

    return (
        <Root>
            <Paper elevation={0} className={classes.paper}>
                <StyledToggleButtonGroup size="small">

                    <ToggleButton aria-label="Expand all Tasks" onClick={expandMore.clickHandler} value="expandmore">
                        <Tooltip title="Expand all Tasks">
                            <ExpandMoreIcon/>
                        </Tooltip>
                    </ToggleButton>

                    <ToggleButton aria-label="Collapse all Tasks" onClick={expandLess.clickHandler} value="expandless">
                        <Tooltip title="Collapse all Tasks">
                            <ExpandLessIcon/>
                        </Tooltip>
                    </ToggleButton>

                </StyledToggleButtonGroup>

                {!hideFirstDivider &&
                    <Divider flexItem orientation="vertical" className={classes.divider}/>
                }

                <StyledToggleButtonGroup size="small">
                    {!zoomIn.hidden &&
                        <ToggleButton aria-label="Zoom In" onClick={zoomIn.clickHandler} disabled={!zoomRestore.hidden} value="zoomin">
                            <Tooltip title="Zoom In">
                                <ZoomInIcon/>
                            </Tooltip>
                        </ToggleButton>
                    }

                    {!zoomOut.hidden &&
                        <ToggleButton aria-label="Zoom Out" onClick={zoomOut.clickHandler} disabled={!zoomRestore.hidden} value="zoomout">
                            <Tooltip title="Zoom Out">
                                <ZoomOutIcon/>
                            </Tooltip>
                        </ToggleButton>
                    }

                    {!zoomToday.hidden &&
                        <ToggleButton aria-label="Zoom to Today" onClick={zoomToday.clickHandler} disabled={zoomToday.disabled || !zoomRestore.hidden} value="today">
                            <Tooltip title="Zoom to Today">
                                <TodayIcon/>
                            </Tooltip>
                        </ToggleButton>
                    }

                    {!zoomFit.hidden &&
                        <ToggleButton aria-label="Fit" onClick={zoomFit.clickHandler} value="fit">
                            <Tooltip title="Fit Tasks">
                                <ZoomOutMapIcon/>
                            </Tooltip>
                        </ToggleButton>
                    }

                    {!zoomRestore.hidden &&
                        <ToggleButton aria-label="Restore" onClick={zoomRestore.clickHandler} value="crop">
                            <Tooltip title="Restore">
                                <CropIcon/>
                            </Tooltip>
                        </ToggleButton>
                    }
                </StyledToggleButtonGroup>

                {!hideSecondDivider &&
                    <Divider flexItem orientation="vertical" className={classes.divider}/>
                }

                <StyledToggleButtonGroup size="small" value={toggle} onChange={handleToggle}>
                    {!displayBaseline.hidden &&
                        <ToggleButton value="baseline" aria-label="Show\Hide Baselines" disabled={displayBaseline.disabled} onClick={displayBaseline.clickHandler}>
                            <Tooltip title="Show\Hide Baselines">
                                <img src={ShowBaselineIcon}/>
                            </Tooltip>
                        </ToggleButton>
                    }
                    {!displayPercentComplete.hidden &&
                        <ToggleButton value="percentComplete" aria-label="Show\Hide % Complete" disabled={displayPercentComplete.disabled} onClick={displayPercentComplete.clickHandler}>
                            <Tooltip title="Show\Hide % Complete">
                                <img src={ShowPercentCompleteIcon}/>
                            </Tooltip>
                        </ToggleButton>
                    }
                    {!displayMilestone.hidden &&
                        <ToggleButton value="milestone" aria-label="Show\Hide Milestones" disabled={displayMilestone.disabled}
                                      onClick={displayMilestone.clickHandler}>
                            <Tooltip title="Show\Hide Milestones">
                                <img src={ShowMilestoneIcon}/>
                            </Tooltip>
                        </ToggleButton>
                    }
                    {!displaySplitParents.hidden && displaySplitParents.hidden !== undefined &&
                        <ToggleButton value="split" aria-label="Split Parents" disabled={displaySplitParents.disabled}
                                      onClick={displaySplitParents.clickHandler}>
                            <Tooltip title="Split Parents">
                                <LinearScaleIcon/>
                            </Tooltip>
                        </ToggleButton>
                    }
                    {!displayTask.hidden &&
                        <ToggleButton value="tasks" aria-label="Show\Hide Tasks" disabled={displayTask.disabled}
                                      onClick={displayTask.clickHandler}>
                            <Tooltip title="Show\Hide Tasks">
                                <EventNoteIcon color={displayTask.disabled? 'disabled' : 'inherit'}/>
                            </Tooltip>
                        </ToggleButton>
                    }
                </StyledToggleButtonGroup>

                {!hideThirdDivider &&
                    <Divider flexItem orientation="vertical" className={classes.divider}/>
                }

                {performanceKey &&
                    <div className={classes.performanceKey}>
                        {performanceKey}
                    </div>
                }

                {!hideFourthDivider &&
                    <Divider flexItem orientation="vertical" className={classes.divider} style={{marginLeft: '16px'}}/>
                }

                {milestoneKey &&
                    <div className={classes.milestoneKey}>
                        {milestoneKey}
                    </div>
                }
            </Paper>
        </Root>
    );
}
